import { Component, OnDestroy, OnInit } from '@angular/core';

import { environment } from '@ap/http';

import { NavMenuService, NavItem } from '@library/modules/menu';
import { Subscription } from 'rxjs';
export const MenuItems: NavItem[] = [
   { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
   // { label: 'Activity Feed', path: '/activityfeed', icon: 'activityfeed' },
   { label: 'Admin', path: '/admin', icon: 'admin' },
   { label: 'Utility', path: '/utility', icon: 'utility', access: 'utility' },
   { label: 'Maintenance', path: '/maintenance', icon: 'maintenance', access: 'maintenance' },
   { label: 'Email Logs', path: '/email-logs', icon: 'description', access: 'email_logs' },
];

@Component({
   selector: 'app-menu',
   templateUrl: './menu.component.html',
   styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
   environment = environment;

   viewport: number;

   sub$: Subscription;

   constructor( private nav: NavMenuService ) {}

   ngOnInit(): void {
      this.sub$ = this.nav.load( MenuItems );
      this.nav.showTracking = false;
      this.nav.title = 'agent portal';
   }

   ngOnDestroy(): void {
      this.sub$.unsubscribe();
   }
}
